import { color } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { ScrollView, StyleSheet, View, ViewStyle } from 'react-native';

interface Props {
  style?: ViewStyle;
  scrollable?: boolean;
  children?: React.ReactNode;
}

const ScreenContainer: FC<Props> = (props) =>
  props.scrollable ? (
    <ScrollView
      contentContainerStyle={StyleSheet.flatten([styles.root, props.style])}
    >
      {props.children}
    </ScrollView>
  ) : (
    <View style={StyleSheet.flatten([styles.root, props.style])}>
      {props.children}
    </View>
  );

// Styles
const styles = StyleSheet.create({
  root: {
    backgroundColor: color.background,
    minHeight: '100%',
    flex: 1,
  },
});

export default ScreenContainer;
